/*
Copyright 2025 TekNix Corporation

This software is proprietary and confidential to TekNix Corporation.
All rights reserved. No part of this software may be reproduced, distributed,
or transmitted in any form or by any means, including photocopying, recording,
or other electronic or mechanical methods, without the prior written permission
of TekNix Corporation, except in the case of brief quotations embodied in
critical reviews and certain other noncommercial uses permitted by copyright law.

For permission requests, write to TekNix Corporation at the address below:
TekNix Corporation
Legal Department

UNAUTHORIZED REPRODUCTION OR DISTRIBUTION IS STRICTLY PROHIBITED.
*/

import { UnstableValue } from '../utils/NamespacedValue';

export enum LocationAssetType {
  Self = 'm.self',
  Pin = 'm.pin',
}

export type MLocationContent = {
  uri: string;
  description?: string | null;
};

export type EitherAnd<T1, T2> = (T1 & T2) | T1 | T2;

export const M_TIMESTAMP = new UnstableValue('m.ts', 'org.matrix.msc3488.ts');

/**
 * The event definition for an m.ts event (in content)
 */
export type MTimestampEvent = EitherAnd<{ [M_TIMESTAMP.name]: number }, { [M_TIMESTAMP.altName]: number }>;

export const M_LOCATION = new UnstableValue('m.location', 'org.matrix.msc3488.location');

export type MLocationEvent = EitherAnd<
  { [M_LOCATION.name]: MLocationContent },
  { [M_LOCATION.altName]: MLocationContent }
>;

export const M_ASSET = new UnstableValue('m.asset', 'org.matrix.msc3488.asset');
export type MAssetContent = { type: LocationAssetType };

export type MAssetEvent = EitherAnd<{ [M_ASSET.name]: MAssetContent }, { [M_ASSET.altName]: MAssetContent }>;
